module.exports = __webpack_public_path__ + "img/perspectives-slide07.97d7f8f7.jpg";